"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = void 0;
const constant_1 = require("./constant");
const locale_1 = require("./locale");
const constant_2 = require("./constant");
const offset_1 = require("./utils/offset");
const addZero = (value) => `${value < 10 ? '0' : ''}${value}`;
const formatDate = (date, format) => {
    const formatAux = typeof format === 'string' ? constant_1.MACRO_TOKEN_TO_FORMAT_OPTS[format] : format;
    if (typeof format === 'string' && !formatAux) {
        const formatParts = format.match(constant_2.FORMATTING_TOKENS) || [];
        const matches = {
            YY: ['year', (value) => `${value.getFullYear()}`.slice(-2)],
            YYYY: ['year', (value) => `${value.getFullYear()}`],
            M: ['month', (value) => `${value.getMonth() + 1}`],
            MM: ['month', (value) => `${addZero(value.getMonth() + 1)}`],
            MMM: ['month', (value) => value.toLocaleString(locale_1.locale.getLocale(), { month: 'short' })],
            MMMM: ['month', (value) => value.toLocaleString(locale_1.locale.getLocale(), { month: 'long' })],
            D: ['day', (value) => `${value.getDate()}`],
            DD: ['day', (value) => `${addZero(value.getDate())}`],
            W: ['weekday', (value) => value.toLocaleString(locale_1.locale.getLocale(), { weekday: 'short' })],
            WW: ['weekday', (value) => value.toLocaleString(locale_1.locale.getLocale(), { weekday: 'long' })],
            H: ['hour', (value) => `${value.getHours()}`],
            HH: ['hour', (value) => `${addZero(value.getHours())}`],
            m: ['minute', (value) => `${value.getMinutes()}`],
            mm: ['minute', (value) => `${addZero(value.getMinutes())}`],
            s: ['second', (value) => `${value.getSeconds()}`],
            ss: ['second', (value) => `${addZero(value.getSeconds())}`],
            OT: ['offset', (value) => `${(0, offset_1.getOffset)(value)}`],
        };
        const values = formatParts.map((token) => {
            const parseTo = matches[token];
            const key = parseTo && parseTo[0];
            const value = parseTo && parseTo[1](date);
            return key ? value : token;
        });
        return values.join('').replace(/[\\[\]]/g, '');
    }
    return date.toLocaleString(locale_1.locale.getLocale(), Object.assign({}, formatAux));
};
exports.formatDate = formatDate;
//# sourceMappingURL=format.js.map